import { render, staticRenderFns } from "./AppProductReviewInfoSection.vue?vue&type=template&id=6ead3315"
import script from "./AppProductReviewInfoSection.vue?vue&type=script&lang=js"
export * from "./AppProductReviewInfoSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports